export const INVITATION_TYPES = {
  SENT: 'SENT',
  RECEIVED: 'RECEIVED'
};
